import React from "react";

export default function SuggestedChips({ chips, onChipClick, C, disabled }) {
  if (!chips || chips.length === 0) return null;
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 10 }}>
      {chips.map((chip, i) => (
        <button
          key={i}
          disabled={disabled}
          onClick={() => onChipClick(chip.question)}
          style={{
            padding: "5px 12px", borderRadius: 16, fontSize: 12, fontWeight: 500,
            background: "rgba(59,130,246,0.08)", border: "1px solid rgba(59,130,246,0.25)",
            color: C.blue, cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.5 : 1,
            fontFamily: "inherit", transition: "all 0.15s",
          }}
          onMouseEnter={e => { if (!disabled) { e.currentTarget.style.background = "rgba(59,130,246,0.16)"; e.currentTarget.style.borderColor = C.blue; }}}
          onMouseLeave={e => { e.currentTarget.style.background = "rgba(59,130,246,0.08)"; e.currentTarget.style.borderColor = "rgba(59,130,246,0.25)"; }}
        >
          {chip.label || chip.question}
        </button>
      ))}
    </div>
  );
}
